export interface IPayment {
  paymentId: number;
  languageId: number;
  elisId: string;
  nameForCart: string;
  descriptionForCart: string;
  provider: string | null;
  price: number;
  paymentPageMethodOrder: number;
  paymentPageMethodOrderMobile: number;
  showInFooter: boolean;
  isEnabled: boolean;
  isEnabledMobile: boolean;
  typeId: string | null;
  paymentGroups: EPaymentGroup[];
  paymentImages: string[];
  savedPaymentToken: boolean;
}

export enum EPaymentGroup {
  ADYEN_WEB_COMPONENTS = 'AdyenWebComponents',
  ADYEN_CREDIT_CARD = 'AdyenCreditCard',
  ADYEN_BANCONTACT = 'AdyenBancontact',
  ADYEN_APPLE_PAY = 'AdyenApplePay',
  ADYEN_GOOGLE_PAY = 'AdyenGooglePay',
  ADYEN_BLIK = 'AdyenBlik',
  ADYEN_IDEAL = 'AdyeniDeal',
  ADYEN_SWISH = 'AdyenSwish',
  ADYEN_MB_WAY = 'AdyenMBWay',
  ADYEN_API = 'AdyenAPI',
  ADYEN_MULTIBANCO = 'AdyenMultibanco',
  ADYEN_YANDEX = 'AdyenYandex',
  ADYEN_TWINT = 'AdyenTwint',
  BRAINTREE_CREDIT_CARD = 'BraintreeCreditCard',
  GLOBAL_PAYMENTS = 'GlobalPayments',
  WORLDLINE_CREDIT_CARD = 'WorldlineCreditCard',
  WORLDLINE_BANCONTACT = 'WorldlineBancontact',
  WORLDLINE_IDEAL = 'WorldlineiDeal',
  PAYPAL = 'Paypal',
  KLARNA = 'Klarna',
  ONE_KLARNA = 'OneKlarna',
  GO_PAY_BANK_TRANSFER = 'GoPayBankTransfer',
  BANK_TRANSFER = 'BankTransfer',
  CASH_OR_CREDIT_CARD = 'CashOrCreditCard',
  CASH_ON_DELIVERY = 'CashOnDelivery',
  NOVA_GLOBAL = 'NovaGlobal',
  PRZELEWY24 = 'Przelewy24',
  PRZELEWY24_PAYPO = 'Przelewy24Paypo',
  DISABLE_FOR_ENGRAVING = 'DisableForEngraving',
  CAC_PAYMENT = 'CaCPayment',
  TOKEN_PAYMENT = 'TokenPayment',
}
